module.exports = __webpack_public_path__ + "img/0499e6_2ef6f7e755b744ecb7203a6de21f3516_mv2.ba530df4.webp";